'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramStore = require('./param-store');

var _paramStore2 = _interopRequireDefault(_paramStore);

var _actionTypeConstants = require('./action-type-constants');

var _actionTypeConstants2 = _interopRequireDefault(_actionTypeConstants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var initialState = {
  currentParams: _paramStore2.default.getAll(),
  previousParams: {},
  changedParams: {}
};

exports.default = function () {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case _actionTypeConstants2.default.PUSH_PARAM_STORE:
      return action.value;

    default:
      return state;
  }
};